<template>
  <span class="flex items-center">
    <template v-if="typeof value === 'object' && value && value.code && value.name">
      <div class="flex justify-center items-center">
        <div
          style="width: 20px;height:20px;border: 1px solid black;border-radius: 20px;"
          :style="{
            background: value.code,
            border: value.code === '#FFFFFF' ? '1px solid black' : ''
          }"
          class="mr-2"
        />
        {{ value.name }}
      </div>
    </template>
    <template v-else>
      {{ value }}
    </template>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: [Object, String]
    }
  }
}
</script>
